import React from "react";
import "@/styles/scss/widgets/_docs.scss";

const DocsWidget = () => {
  return (
    <div className="docs-widget mb-3">
      <DocsHeader />
      <div className="body">
        <DocItem />
      </div>
    </div>
  );
};

DocsWidget.propTypes = {};

const DocsHeader = () => {
  return (
    <div className="header">
      <div className="row">
        <div className="col">
          <span className="title">Document Center</span>
        </div>
        <div className="col text-end">
          <span className="text-danger fw-bold">+ Upload document</span>
        </div>
      </div>
    </div>
  );
};

const DocItem = () => {
  return (
    <div className="note-item d-flex align-items-center p-3 c-pointer">
      <div className="pe-3">
        <img className="icon" src="/pdf.png" />
      </div>
      <div>
        <div className="fw-medium ">Authorization Form</div>
        <div className="fs-10 text-gray">{new Date().toString()}</div>
      </div>
      <div className="flex-grow-1">
        <div className="float-end">
          <i className="bi bi-trash fs-16 text-danger" />
        </div>
      </div>
    </div>
  );
};

export default DocsWidget;
